<template>
  <div class="payment-results">
    <!--<van-nav-bar class="" title="支付结果" left-arrow @click-left="onClickLeft" />-->
    <div class="buy-knowledge">
      <div class="buy-success" v-if="placeOrder.orderNo">
        <img class="icon" src="../../assets/mall/buy-success.png" alt="">
        <div class="buy-text">
          <div class="text">购买成功</div>
          <span class="num">￥{{ placeOrder.newPreviewInfo.actualAmount | filter2 }}</span>
        </div>
      </div>
      <div class="buy-error" v-if="!placeOrder.orderNo">
        <div class="buy-text">
          <div class="text">购买失败</div>
        </div>
      </div>
    </div>


    <div class="btn-con">
      <div class="btn" @click="checkOrderBuy">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data(){
    return{
      placeOrder: this.session('placeOrder')
    }
  },
  created(){
    if(!this.placeOrder){
      this.$router.go(-2)
    }
    console.log(this.placeOrder)
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1)
    },

    checkOrderBuy(){
      this.$router.go(-2)
    }
  },
  beforeDestroy(){
    // 离开本页面时：
    this.removeSession('placeOrder')
  }
}
</script>

<style lang="less" scoped>
.payment-results{
  .buy-knowledge{
    .buy-success, .buy-error{
      .icon{
        display: block;
        width: 69px;
        height: 69px;
        margin: 60px auto 15px;
      }
      .buy-text{
        font-size: 16px;
        color: #333;
        text-align: center;
        .num{
          font-size: 36px;
        }
      }
    }
  }
  .btn-con{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    .btn{
      width: 335px;
      height: 44px;
      color: #fff;
      font-size: 18px;
      border-radius: 5px;
      background-color: #2b86cc;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>